import React from "react";
import { useSite } from "@/context/SiteContext";
import { MEDIA } from "@/constants/media";
import { Reveal, Overline } from "@/components/Reveal";

const TILES = [
  { src: MEDIA.aboutTailoring, span: "sm:col-span-2 sm:row-span-2", label: { id: "Penyelesaian Jahitan", en: "Tailoring Finish" } },
  { src: MEDIA.machine1, span: "", label: { id: "Lini Produksi", en: "Production Line" } },
  { src: MEDIA.heroSilk, span: "", label: { id: "Material Premium", en: "Premium Material" } },
  { src: MEDIA.machine2, span: "sm:col-span-2", label: { id: "Presisi Mesin", en: "Machine Precision" } },
];

const Gallery = () => {
  const { t, lang } = useSite();
  const g = t.gallery;

  return (
    <section id="gallery" data-testid="gallery-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="max-w-2xl">
          <Reveal>
            <Overline>{g.overline}</Overline>
            <h2 className="mt-6 font-heading text-4xl font-light leading-tight tracking-tight sm:text-5xl">
              {g.title}
            </h2>
            <p className="mt-6 font-body text-base font-light text-muted-foreground">{g.subtitle}</p>
          </Reveal>
        </div>

        <div className="mt-14 grid auto-rows-[220px] grid-cols-1 gap-4 sm:grid-cols-3 sm:auto-rows-[240px]">
          {TILES.map((tile, i) => (
            <Reveal key={i} delay={i * 0.08} className={tile.span}>
              <div
                data-testid={`gallery-item-${i}`}
                className="group relative h-full w-full overflow-hidden"
              >
                <img
                  src={tile.src}
                  alt={tile.label[lang]}
                  className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-70 transition-opacity duration-500 group-hover:opacity-90" />
                <div className="absolute bottom-0 left-0 p-6">
                  <span className="font-body text-xs uppercase tracking-luxe text-white/70">
                    0{i + 1}
                  </span>
                  <p className="mt-1 font-heading text-xl text-white">{tile.label[lang]}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
